import { Outlet, useLoaderData } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Container,
  Header as HeaderSuite,
  Content,
  Footer,
  Sidebar,
} from "rsuite";
import { AuthProvider } from "../context/AuthContext";
import MainSidebar from "../components/MainSidebar";
import MainNavigation from "../components/MainNavigation";
import MainFooter from "../components/MainFooter";
import "./Root.css";

function RootLayout() {
  const user = useLoaderData();
  const theme = useSelector((state) => state.theme.currentTheme);
  const expanded = useSelector((state) => state.sidebar.isExpanded);

  return (
    <AuthProvider user={user}>
      <Container className={theme}>
        <HeaderSuite>
          <MainNavigation />
        </HeaderSuite>
        <Container className="scrollable-container">
          <Container className="flex-container-row">
            <Sidebar
              style={{ width: "auto", flex: "0 0 auto" }}
              className="fixed"
            >
              {user ? <MainSidebar /> : null}
            </Sidebar>
            <Content
              className={
                !user
                  ? "flex-container-column main-height"
                  : expanded
                  ? "flex-container-column main-height collapse-in"
                  : "flex-container-column main-height collapse-out"
              }
            >
              <div className="main-content flex-container-column">
                <Outlet />
              </div>
              <Footer>
                <MainFooter />
              </Footer>
            </Content>
          </Container>
        </Container>
      </Container>
    </AuthProvider>
  );
}

export default RootLayout;
